// src/App.tsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

// @ts-ignore (or add `declare module '*.ico';` in a custom .d.ts)
import favicon from './assets/images/favicon.ico';
import Route from './Routes';
import './assets/scss/themes.scss';

function App() {
  return (
    <>
      <Helmet>
        <link rel="icon" href={favicon} type="image/x-icon" />
        <meta name="twitter:image" content={favicon} />
      </Helmet>
      <Route />
    </>
  );
}

export default App;
